<template>
  <div class="lyk_table lyk-table-container">
    <!-- <el-main> -->
    <el-table ref="refDataTable" :data="tableData.tData" :height="height" :header-cell-style="headerCellStyle"
              :stripe="stripe"
              :border="border" id="out-table" v-loading="loading" element-loading-text="数据加载中"
              :row-class-name="rowclassname"
              :header-cell-class-name="headercellclassname" @cell-click="cellClick" @cell-dblclick="cellDblclick"
              :cell-class-name="tableData.cellclassname" :row-style="rowstyle" :cell-style="cellStyle" :row-key="rowKey"
              :expand-row-keys="[]" style="width: 100%" @select="selectionChange" @select-all="selectionChange"
              @sort-change="sortChange" :default-expand-all="false" :indent="24"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <!--是否展示多选框-->
      <el-table-column v-if="tableData.isMultiple" type="selection" align="center" width="50"></el-table-column>
      <!--是否展示单选框-->
      <el-table-column v-if="tableData.isSingle" align="center" width="50">
        <template slot-scope="scope">
          <el-radio :label="scope.$index" v-model="templateRadio"
                    @change.native="getTemplateRow(scope.$index,scope.row)">&nbsp
          </el-radio>
        </template>
      </el-table-column>
      <!--是否展示列序号-->
      <el-table-column v-if="tableData.isRank" type="index" align="center" width="80" label="序号" :index="numerical">
      </el-table-column>
      <!-- <el-table-column v-if="tableData.expand" type="expand">
         <template slot-scope="scope"> 
           <p >{{scope.row.projectList}}</p>
           </template>
      </el-table-column> -->
      <template v-for="(tit,index) in tableData.tHead">
        <template v-if="tit.isHide">
          <!--type.image图片展示类型-->
          <el-table-column v-if="tit.type === 'image'" :key="index" :label="tit.name" :width="tit.width?tit.width:''"
                           :formatter="formatter" v-show="!tit.isHide">
            <template slot-scope="scope">
              <!-- (type, row, scope, field, imgUrl)  -->
              <span
                @click="allClick(tit.type,scope.row,scope,tit.field,tit.callback?tit.callback(scope.row[tit.field],scope.row):'')">
                <el-image style="width:48px;height:48px;margin:10px 0px;"
                          :src="tit.callback?tit.callback(scope.row[tit.field],scope.row):scope.row[tit.field]" alt>
                  <div slot="error" class="default_image">
                    <img src="../../assets/img/common/default.png" alt="">
                  </div>
                </el-image>
              </span>
            </template>
          </el-table-column>


          <!-- 编辑排序 -->
          <el-table-column v-else-if="tit.type === 'textInput'" :label="tit.name"
                           :width="tit.width?tit.width:''"
                           :formatter="formatter" v-show="!tit.isHide" :align="tit.align ? tit.align: 'center'">
            <template slot-scope="scope">
              <!-- (type, row, scope, field, imgUrl)  -->
              <div>
                <span v-if="tit.isShow">{{scope.row[tit.field]}}</span>
                <el-input-number v-else
                                 v-model="scope.row[tit.field]"
                                 @change="paixuEditor(scope.$index,scope.row)"
                                 :min="0" :step="1"
                                 :precision="0"
                                 :size="small"
                                 :controls="false"
                                 :max="999"></el-input-number>
                <!--<input type="number" style="width:39px;height:18px;text-align:center;"-->
                       <!--@blur="paixuEditor(scope.$index,scope.row)" v-else v-model="scope.row[tit.field]" >-->
                       <!-- scope.row[tit.field] = scope.row[tit.field] ? scope.row[tit.field].replace(/\D/g,'') : ''  -->
              </div>
            </template>
          </el-table-column>


          <!-- 处理多个操作按钮 -->
          <el-table-column v-else-if="tit.type === 'imgList'"  :label="tit.name"
                           :width="tit.width?tit.width:''"
                           :formatter="formatter" v-show="!tit.isHide" :align="tit.align ? tit.align: 'center'">
            <template slot-scope="scope">
              <!-- (type, row, scope, field, imgUrl)  -->
              <div class="saas-image">
                <span v-for="(item,itemIndex) in tit.list" :key="itemIndex">
                  <span
                    @click="allClick(tit.type,scope.row,scope,tit.field,tit.callback?tit.callback(scope.row[tit.field],scope.row):'',itemIndex)">{{item}}</span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'img'"  :label="tit.name" :width="tit.width?tit.width:''"
                           :formatter="formatter" v-show="!tit.isHide" :align="tit.align ? tit.align: 'center'">
            <template slot-scope="scope">
              <!-- (type, row, scope, field, imgUrl)  -->
              <div :style="{width:tit.width ?tit.width + 'px': '300px', height: tit.height?tit.height + 'px': '300px' }"
                   style="margin:21px 0px 19px 0px">
                <img :src="scope.row[tit.field]" alt="" style="width:100%;">
              </div>
            </template>
          </el-table-column>
          <!-- 图片加文字 -->
          <el-table-column v-else-if="tit.type === 'imageText'" :label="tit.name"
                           :width="tit.width?tit.width:''"
                           :formatter="formatter" v-show="!tit.isHide" :align="tit.align ? tit.align: 'center'">
            <template slot-scope="scope">
              <!-- (type, row, scope, field, imgUrl)  -->
              <span
                class="img-text"
                @click="allClick(tit.type,scope.row,scope,tit.field,tit.callback?tit.callback(scope.row[tit.field],scope.row):'')">
                <el-image style="width:54px;height:54px;margin:18px 0px"
                          :src="tit.callback?tit.callback(scope.row[tit.field],scope.row):scope.row[tit.field]" alt>
                  <div slot="error" class="default_image">
                    <img src="../../assets/img/common/default.png" alt="">
                  </div>
                </el-image>
                <div class="text-field" :style="{color:tit.color}" v-html="scope.row[tit.fieldName]"
                     v-if="scope.row[tit.fieldName] === 0"></div>
                <div class="text-field" :style="{color:tit.color}"
                     v-html="scope.row[tit.fieldName]?scope.row[tit.fieldName]:'-'" v-else></div>
              </span>
            </template>
          </el-table-column>
          <!--switch开关-->
          <el-table-column v-else-if="tit.type === 'switch'"  :label="tit.name"
                           :width="tit.width?tit.width:''" :formatter="formatter" v-show="!tit.isHide">
            <template slot-scope="scope">
              <div class="t_switch">
                <el-switch v-model="scope.row[tit.field]" @change="switchChange(scope.row)"
                           :width="tit.configObj?tit.configObj.width:60"
                           :active-text="tit.configObj?tit.configObj.activeText:'在职'"
                           :inactive-text="tit.configObj?tit.configObj.inactiveText:'离职'" :active-value="0"
                           :inactive-value="1">
                </el-switch>
              </div>
            </template>
          </el-table-column>
          <!--type.custom用户自定义类型可配合wordwrap字符定义数据换行位置，和textRowSize限制数据展示行数-->
          <el-table-column v-else-if="tit.type === 'custom'"  :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :formatter="formatter" v-show="!tit.isHide">
            <template slot-scope="scope">
              <div :class="textRowClassName[tit.textRowSize]"
                   :title="tit.textRowSize?tit.hideTit?'':scope.row[tit.field]:''">
                <span v-html="scope.row[tit.field].split(tit.wordwrap||' ').join('<br />')"></span>
              </div>
            </template>
          </el-table-column>
          <!--type.function万能数据处理类型配合callback回调函数处理展示内容，和textRowSize限制数据展示行数-->
          <el-table-column v-else-if="tit.type === 'function'"  :prop="tit.field" :label="tit.name"
                           :sortable="tit.sortable?'custom':false" :width="tit.width?tit.width:''"
                           :formatter="formatter"
                           :align="tit.align ? tit.align : 'center'" :header-align="tit.align ? tit.align : 'center'"
                           :show-overflow-tooltip="true" v-show="!tit.isHide">
            <template slot-scope="scope">
              <div :class="textRowClassName[tit.textRowSize]?textRowClassName[tit.textRowSize]:'ellipsis'"
                   :title="tit.textRowSize?tit.hideTit?'':tit.callback(scope.row[tit.field],scope.row):''">
                <span v-html="tit.callback(scope.row[tit.field],scope.row,rowCommonData)" v-if="tit.click"
                      @click="allClick(tit.field, scope.row,scope,index)" style="cursor: pointer;"></span>
                <span v-html="tit.callback(scope.row[tit.field],scope.row,rowCommonData)" v-else></span>
              </div>

            </template>
          </el-table-column>
          <!-- 弹窗 -->
          <el-table-column v-else-if="tit.type === 'dialog'":prop="tit.field" :label="tit.name"
                           :sortable="tit.sortable?'custom':false" :width="tit.width?tit.width:''"
                           :formatter="formatter"
                           v-show="!tit.isHide">
            <template slot-scope="scope">
              <div class="flex">
                <div style="margin-right:10px;"><span v-html="tit.callback(scope.row[tit.field],scope.row)"></span>
                </div>
                <div class="flex1">
                  <el-button :class="textRowClassName[tit.textRowSize]" type="text"
                             :title="tit.textRowSize?tit.hideTit?'':tit.text:''"
                             @click="allClick(tit.type, scope.row,scope)">
                    <span v-html="tit.text"></span>
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>
          <!--actionBtns横向展示操作选项-->
          <el-table-column v-else-if="tit.type === 'actionBtns'" :label="tit.name" fixed="right"
                           :width="tableData.actionBtWidth ? tableData.actionBtWidth :'' " :key="tit.index">
            <template slot-scope="scope">
              <template v-for="btn of tit.callback(scope.row[tit.field],scope.row)">
                <template v-if="btn.callback && typeof btn.callback === 'function'">
                  <el-button type="text" :key="btn.index" :disabled="btn.disabled"
                             v-if="btn.callback(scope.row)"
                             @click.stop="allClick(btn.type, scope.row,scope)">
                    <span v-html="btn.label"></span>
                  </el-button>
                </template>
                <!--<template v-if="btn.filter !== undefined && btn.filter != null">-->
                <!--<el-button type="text" :key="btn.index" :disabled="btn.disabled"-->
                <!--v-if="btn.filter.needel.indexOf(btn.filter.callback?btn.filter.callback(scope.row[btn.filter.field]):scope.row[btn.filter.field]) > -1"-->
                <!--@click.stop="allClick(btn.type, scope.row,scope)">-->
                <!--<span v-html="btn.label"></span>-->
                <!--</el-button>-->
                <!--</template>-->
                <template v-else>
                  <el-button :key="btn.index" type="text" :disabled="btn.disabled"
                             @click.stop="allClick(btn.type, scope.row,scope)">
                    <span v-html="btn.label"></span>
                  </el-button>
                </template>
              </template>
            </template>
          </el-table-column>
          <!--actionSelectBtns下拉展示操作选项-->
          <el-table-column v-else-if="tit.type === 'actionSelectBtns'" :label="tit.name" 
                           :width="tableData.actionBtWidth ? tableData.actionBtWidth :'' ">
            <template slot-scope="scope">
              <el-dropdown placement="bottom" @command="optionHandleClick($event,scope.row,scope)">
                <el-button type="primary">
                  {{tit.name}}
                  <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
                </el-button>
                <el-dropdown-menu :class="{optionSelect:true}" slot="dropdown">
                  <template v-for="btn of tit.callback(scope.row[tit.field],scope.row)">
                    <template v-if="btn.filter !== undefined && btn.filter != null">
                      <el-dropdown-item :key="btn.index" :disabled="btn.disabled"
                                        v-if="btn.filter.needel.indexOf(btn.filter.callback?btn.filter.callback(scope.row[btn.filter.field]):scope.row[btn.filter.field])>-1"
                                        :command="btn.type">
                        <span v-html="btn.label"></span>
                      </el-dropdown-item>
                    </template>
                    <template v-else>
                      <el-dropdown-item :key="btn.index" :command="btn.type" :disabled="btn.disabled">
                        <span v-html="btn.label"></span>
                      </el-dropdown-item>
                    </template>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'priceInput'"  :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false">
            <template slot-scope="scope">
              <div style="margin:5px;">
                <el-input v-model="scope.row[tit.field]" :placeholder="tit.name" size="small" v-input-filter:price
                          @blur="allClick(tit.type, scope.row,scope)"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'numberWordInput'" :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false">
            <template slot-scope="scope">
              <div style="margin:5px;">
                <el-input v-model="scope.row[tit.field]" :placeholder="tit.name" size="small" v-input-filter:numberWord
                          @blur="allClick(tit.type, scope.row,scope)"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'editInput'"  :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false">
            <template slot-scope="scope">
              <div style="margin:5px;">
                <el-input v-model="scope.row[tit.field]" :placeholder="tit.name" size="small"
                          @blur="allClick(tit.type, scope.row,scope)"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'numberInputSelect'" :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false">
            <template slot-scope="scope">
              <div style="margin:5px;">
                <el-input v-model="scope.row[tit.field]" :placeholder="tit.name" size="small" v-input-filter:int
                          style="width:100px" @blur="allClick(tit.type, scope.row,scope)" maxlength="8"></el-input>
                <el-select v-model="scope.row[tit.optionsCfg.typeField]" slot="append" :style="tit.optionsCfg.style"
                           size="small">
                  <el-option :label="item.label" :value="item.value"
                             v-for="(item,index) in scope.row[tit.optionsCfg.options]" :key="index"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'inputSelect'" :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false">
            <template slot-scope="scope">
              <div style="margin:5px;">
                <el-input v-model="scope.row[tit.field]" :placeholder="tit.name" size="small"
                          @blur="allClick(tit.blur, scope.row,scope)">
                  <el-select v-model="scope.row[tit.typeField]" slot="append" style="width: 60px">
                    <el-option :label="item.label" :value="item.value" v-for="(item,index) in scope.row[tit.options]"
                               :key="index"></el-option>
                  </el-select>
                </el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'numberInput'"  :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:180" :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false">
            <template slot-scope="scope">
              <div style="margin:5px;">
                <el-input v-model="scope.row[tit.field]" :placeholder="tit.name" size="small" v-input-filter:int
                          style="width:150px" @blur="allClick(tit.blur, scope.row,scope)" maxlength="8"> <span
                  slot="append"
                  v-if="tit.text"><span>{{tit.text}}</span></span></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'date'"  :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false">
            <template slot-scope="scope">
              <div style="margin:5px;">
                <span v-if="tit.callback && tit.callback(scope.row[tit.field],scope.row)">-</span>
                <el-date-picker v-else :type="tit.dateType||'datetime'" v-model="scope.row[tit.field]"
                                :picker-options="tit.pickerOptions?tit.pickerOptions:{}" :placeholder="tit.name"
                                size="small"
                                style="width:80%">
                </el-date-picker>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'selectOptions'"  :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false">
            <template slot-scope="scope">
              <div style="margin:0px 5px;">
                <el-select v-model="scope.row[tit.field]" :placeholder="tit.name" size="small" style="width:100%;"
                           @change="allClick(tit.field, scope.row,scope)">
                  <el-option :label="item.label" :value="item.value" v-for="(item,index) in scope.row[tit.options]"
                             :key="index"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'cascaderOptions' ":prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false">
            <template slot-scope="scope">
              <div style="margin:5px;">
                <el-cascader v-model="scope.row[tit.field]" :placeholder="tit.name" :options="scope.row[tit.options]"
                             size="small" :props="{ checkStrictly: true }" clearable></el-cascader>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'soleCode'"  :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false">
            <template slot-scope="scope">
              <div style="margin:5px;">
                <span style="margin-right:10px;">{{scope.row[tit.field]||0}}</span>
                <el-button type="text" @click="allClick(tit.field, scope.row,scope)"
                           v-if="tit.callback(scope.row[tit.field],scope.row)">
                  {{tit.callback(scope.row[tit.field],scope.row).text}}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <!--二维码小弹框-->
          <el-table-column v-else-if="tit.type === 'qrcode'" :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :align="tit.align" :header-align="tit.align"
                           :sortable="tit.sortable?true:false" v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <img src="../../assets/img/common/code.png" alt="" class="table_qrcode_btn"
                   @click="showQrcode(tit, scope.row,scope)"/>
              <span v-html="scope.row[tit.field]"></span>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'select'"  :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false">
            <template slot-scope="scope">
              <div style="margin:5px;">
                <el-select v-model="scope.row[tit.field]" :placeholder="tit.name">
                  <el-option label="每日" :value="1"></el-option>
                  <el-option label="每周" :value="2"></el-option>
                  <el-option label="每月" :value="3"></el-option>
                  <el-option label="每季" :value="4"></el-option>
                  <el-option label="每年" :value="5"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="tit.type === 'batchType'"  :prop="tit.field" :label="tit.name"
                           :width="tit.width?tit.width:''" :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true"
                           :fixed="tit.fixed?tit.fixed:false">
            <template slot-scope="scope">
              <div style="margin:5px;">
                <div v-if="scope.row['depositType'] === 1">
                  <el-input v-model="scope.row[tit.field]" :placeholder="tit.name" size="small" v-input-filter:int
                            @blur="allClick(tit.type, scope.row,scope)" maxlength="8"></el-input>
                  <!-- <el-input-number v-model="scope.row[tit.field]" controls-position="right" :min="0" :precision="0"
                    :max="999999" size="small" @change="allClick(tit.change, scope.row,scope)"> -->
                  <!-- </el-input-number> -->
                </div>
                <div v-else>
                  <div>
                    <span>{{scope.row[tit.field]}}</span>
                    <el-button @click="allClick(tit.field, scope.row,scope)" type="text" size="small">唯一码</el-button>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <!--默认数据展示没有type时走这个分支-->
          <el-table-column v-else  :prop="tit.field" :label="tit.name" :width="tit.width?tit.width:''"
                           :align="tit.align ? tit.align : 'center'" :header-align="tit.align ? tit.align : 'center'"
                           :sortable="tit.sortable?true:false"
                           v-show="tit.isHide?false:true" :fixed="tit.fixed?tit.fixed:false"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-html="scope.row[tit.field]" v-if="scope.row[tit.field] === 0"></span>
              <span v-html="scope.row[tit.field]?scope.row[tit.field]:'-'" v-else></span>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
    <!--分页配置-->
    <div v-if="ispagination" class="lyk_pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="ispagination && ajax.data ? ajax.data.pageNumber:''" :page-sizes="[15,50,100]"
                     :page-size="ispagination && ajax.data ? ajax.data.pageSize:''"
                     layout="total, sizes, prev, pager, next,jumper"
                     :total="tableData.total||0"></el-pagination>
    </div>
    <!-- 用户自定义设置表格 -->
    <div class="seeting_dialog clear_el_dialog">
      <el-dialog title :visible.sync="dialogVisible" width="640px" :close-on-click-modal="false">
        <h3>自定义表格</h3>
        <div class="dialog_content">
          <div class="thead">
            <el-row>
              <el-col :span="6">列名</el-col>
              <el-col :span="6">别名</el-col>
              <el-col :span="6">显示</el-col>
              <el-col :span="6">操作</el-col>
            </el-row>
          </div>
          <div class="tbody">
            <div v-for="(item,index) in  tableData.tHead" :key="index" class="table_col">
              <el-row>
                <el-col :span="6" style="text-align:center;height:40px;">
                  <p>{{item.name}}</p>
                </el-col>
                <el-col :span="6" style="text-align:center;height:40px;">
                  <el-input type="text" :placeholder="item.name" size="mini" v-model="item.name" readonly></el-input>
                </el-col>
                <el-col :span="6" style="text-align:center;height:40px;">
                  <div @click="showChange()" style="text-align:center;">
                    <el-switch v-model="item.isHide"></el-switch>
                  </div>
                </el-col>
                <el-col :span="6" style="text-align:center;height:40px;">
                  <span class="el-icon-sort-up" style="margin-right:5px;" @click="sortUp(index)"></span>
                  <span class="el-icon-sort-down" @click="sortDown(index)"></span>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="" v-if="qrcodeDialogVisible">
      <el-dialog title="查看二维码" v-if="qrcodeDialogVisible" :visible.sync="qrcodeDialogVisible" width="30%"
                 :before-close="handleClose">
        <qr-code-modle :qrCodeData="qrCodeData"></qr-code-modle>
      </el-dialog>
    </div>
    <!-- </el-main> -->
  </div>
</template>
<script>
  import GlobalUtil from '@/utils/globalUtil'
  import qrCodeModle from '@/components/common/qrCodeModle.vue'
  import FileSaver from 'file-saver'
  import XLSX from 'xlsx'
  import {
    setTimeout
  } from 'timers'

  export default {
    components: {
      qrCodeModle
    },
    data() {
      return {
        paixuList: [],
        templateRadio: '',
        // defaultImg: 'this.src="' + require('../../assets/img/common/timg.jpg') + '"',
        loading: true,
        dialogVisible: false,
        ajax: {},
        tableData: this.inTableData,
        dialogData: [],
        serachFilte: this.inSerachFilte,
        headercellstyle: {
          background: '#F9F9F9',
          fontSize: '14px',
          fontFamily: 'PingFangSC-Medium,PingFang SC',
          fontWeight: 'bold',
          color: 'rgba(0,0,0,0.85)',
          // textAlign:'center'
        },
        cellstyle: {
          fontSize: '14px',
          fontFamily: 'PingFangSC-Medium,PingFang SC',
          color: 'rgba(0,0,0,0.65)',
        },
        rowstyle: {
          height: '40px',
          textAlign: 'left'
        },
        sortData: {},
        textRowClassName: [
          '',
          'textLineSize1',
          'textLineSize2',
          'textLineSize3',
          'textLineSize4',
          'textLineSize5'
        ],
        selectionIndex: [],
        //当前页选中项
        currentPageSelection: [],
        //其他页选中项
        otherPageSelection: [],
        //全部选中项
        allPageSelection: [],
        qrcodeDialogVisible: false,
        qrCodeData: {}
      }
    },
    props: {
      rowCommonData: {
        type: Object,
        default: function () {
          return {}
        }
      },
      rowKey: {
        type: String,
        default: function () {
          return 'id'
        }
      },
      height: {},
      // 检测flush发生变化刷新数据
      flush: '',
      isRank: true,
      isAllMultiple: {
        open: false,
        callback: function (item) {
          return item.id
        }
      },
      border: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      isAjax: {
        type: Boolean,
        default: function () {
          return true
        }
      },
      stripe: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      // 是否分页
      ispagination: {
        type: Boolean,
        default: function () {
          return true
        }
      },
      // 排序格式化
      sortFormatter: {
        type: Function,
        default: function (obj) {
          return obj
        }
      },
      // 搜索过滤把搜索字段及数据传过来自动搜索过滤
      inSerachFilte: {},
      // AJAX请求配置
      inAjax: {
        type: Object,
        default: function () {
          return {
            url: '',
            method: 'post',
            data: {
              pageNumber: 1,
              pageSize: 15
            }
          }
        }
      },
      // table表参数配置
      inTableData: {
        type: Object,
        default: function () {
          return {
            // 表头字段配置
            tHead: [],
            // 表内容自动渲染
            tData: [],
            // 总条数自动渲染
            total: 0,
            // 控制操作选项列的宽度

            actionBtWidth: '',
            // 配置操作按钮actionSelectBtns为下拉按钮，actionBtns为平铺按钮
            actionBtns: [{
              type: 'info',
              label: '<span style=\'color: #1881BF;font-size: 12px;text-decoration: underline\'>详情</span>',
              // 控制某个字段数据为多少时显示按钮，不设置则全部显示
              filter: {
                field: 'id',
                needel: [1, 2, 3, 4, 5]
              }
            },
              {
                type: 'hulve',
                label: '<span style=\'color: #1881BF;font-size: 12px;text-decoration: underline\'>忽略</span>'
              }
            ],
            // 操作选项列的下拉按钮配置
            actionSelectBtns: [{
              type: '\'info',
              label: '<span style=\'color: #1881BF;font-size: 12px;text-decoration: underline\'>详情</span>',
              // 控制某个字段数据为多少时显示按钮，不设置则全部显示
              filter: {
                field: '\'id',
                needel: [1, 2, 3, 4, 5]
              }
            },
              {
                type: 'hulve',
                label: '<span style=\'color: #1881BF;font-size: 12px;text-decoration: underline\'>忽略</span>'
              }
            ],
            // 配置是否显示多选框
            isMultiple: false,

          }
        }
      },
      // 枚举字段数据对应数据
      formatter: {},
      // 设置头部某列类名方便控制样式
      headercellclassname: {},
      // 设置tbody部份某列类名方便控制样式
      cellclassname: '',
      //初始化默认选中项
      inAllPageSelection: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    created() {
      this.ajax = GlobalUtil.deepClone(this.inAjax)
      if (this.inAllPageSelection) {
        this.allPageSelection = this.inAllPageSelection
      }
      this.dialogData = this.tableData.tHead
      for (let i = 0; i < this.dialogData.length; i++) {
        if (this.tableData.tHead[i].isHide) {
          this.dialogData[i].isHide = false
          this.tableData.tHead[i].isHid = false
        } else {
          this.dialogData[i].isHide = true
          this.tableData.tHead[i].isHid = true
        }
        // this.tableData.tHead[i].isHide =this.tableData.tHead[i].isHide?false:true;
      }
    },
    mounted() {
      if (this.ajax.url) {
        this.getList()
      } else {
        this.loading = false
      }
    },
    methods: {
      headerCellStyle(data) {
        if (data.columnIndex == 0 && !this.tableData.isMultiple && !this.tableData.isRank) {
          return {
            background: '#F9F9F9',
            fontSize: '12px',
            fontFamily: 'PingFangSC-Medium,PingFang SC',
            fontWeight: 'bold',
            color: 'rgba(0,0,0,0.85)',
          }
        } else {
          return {
            background: '#F9F9F9',
            fontSize: '12px',
            fontFamily: 'PingFangSC-Medium,PingFang SC',
            fontWeight: 'bold',
            color: 'rgba(0,0,0,0.85)',
            // textAlign:'center'
          }
        }
      },
      cellStyle(data) {
        if (data.columnIndex == 0 && !this.tableData.isMultiple && !this.tableData.isRank) {
          if (data.row.children) {
            return {
              fontSize: '12px',
              fontFamily: 'PingFangSC-Medium,PingFang SC',
              color: 'rgba(0,0,0,0.65)',
              borderColor: '##EBEEF5',
            }
          } else {
            return {
              fontSize: '12px',
              fontFamily: 'PingFangSC-Medium,PingFang SC',
              color: 'rgba(0,0,0,0.65)',
              borderColor: '##EBEEF5',
              textIndent: '1em'
            }
          }

        } else {
          return {
            fontSize: '12px',
            fontFamily: 'PingFangSC-Medium,PingFang SC',
            color: 'rgba(0,0,0,0.65)',
            borderColor: '##EBEEF5',
          }
        }
      },
      // 返回更新后的数据
      editorTable() {
        return this.tableData
      },
      switchChange(data) {
        this.$emit('switchChange', data)
      },
      showChange() {
        this.$forceUpdate()
      },
      sortUp(index) {
        if (index !== 0) {
          this.dialogData[index] = this.dialogData.splice(
            index - 1,
            1,
            this.dialogData[index]
          )[0]
        } else {
          this.dialogData.push(this.dialogData.shift())
        }
        this.tableData.tHead = this.dialogData
        this.$forceUpdate()
      },
      sortDown(index) {
        if (index !== this.dialogData.length - 1) {
          this.dialogData[index] = this.dialogData.splice(
            index + 1,
            1,
            this.dialogData[index]
          )[0]
        } else {
          this.dialogData.unshift(this.dialogData.splice(index, 1)[0])
        }
        this.tableData.tHead = this.dialogData
      },
      settingTable() {
        this.dialogVisible = true
      },
      handleClose() {
        this.dialogVisible = false
        this.qrcodeDialogVisible = false
      },
      numerical(i) {
        if (this.ajax.data && this.ajax.data.pageNumber) {
          return (
            (this.ajax.data.pageNumber - 1) * this.ajax.data.pageSize + i + 1
          )
        } else {
          return ++i
        }

      },
      getList() {
        this.loading = true
        let posdata = Object.assign({},
          GlobalUtil.deepClone(this.ajax.data),
          GlobalUtil.deepClone(this.serachFilte),
          this.sortData
        )
        // console.log(this.ajax.data)
        // console.log(posdata)
        // console.log('getList')
        if (!this.isAjax) return
        this.$axios
          .ajax({
            url: this.ajax.url,
            method: this.ajax.method,
            data: posdata
          })
          .then(res => {
            let data = res.data
            if (
              (data.total > 9) & (data.pageNumber > 1) &&
              data.list.length === 0
            ) {
              --this.ajax.data.pageNumber
              this.getList()
              return
            }
            if (
              this.ajax.callback &&
              typeof this.ajax.callback === 'function'
            ) {
              this.tableData.tData = this.ajax.callback(data)
              this.$emit('successCallback', this.tableData.tData)

            } else {
              this.tableData.tData = []
              this.tableData.tData = data.list ? data.list : data
              this.$emit('successCallback', this.tableData.tData)
            }
            if (data) {
              this.tableData.total = data.total
            }
            this.loading = false
            this.$emit('ajaxOut')
            if (this.isAllMultiple && this.isAllMultiple.open) {
              this.splitSelection()
            } else {
              this.toggleSelection()
            }
          })
          .catch(error => {
            // console.log(error)
          })
      },
      allClick(type, row, scope, field, imgUrl, index) {
        // console.log('allClick')
        // if (type === 'image') {
        //   console.log(row, field, '==================')
        //
        //   // GlobalUtil.bigImage(row[field])
        //   // this.dialogVisible = true
        //   return
        // }
        const outData = {
          type: type,
          rowData: row,
          rowindex: scope.$index,
          field,
          index
        }
        this.$emit('rowClick', outData)
      },
      cellClick(row, column, cell, event) {
        const outData = {
          row: row,
          column: column,
          cell: cell,
          event: event
        }
        this.$emit('cellClick', outData)
      },
      cellDblclick(row, column, cell, event) {
        const outData = {
          row: row,
          column: column,
          cell: cell,
          event: event
        }
        this.$emit('cellDbClick', outData)
      },
      getTemplateRow(index, row) {
        console.log(row)
        console.log(index)
        let obj = {
          rowIdx: index,
          rowData: row
        }
        this.$emit('selection', obj)
      },
      paixuEditor(index, row) {
        let obj = {
          rowIdx: index,
          rowData: row
        }
        this.paixuList.push(obj)
        this.$emit('paixuList', this.paixuList)
      },
      selectionChange(selection) {
        if (this.isAllMultiple && this.isAllMultiple.open) {
          this.mergeSelection(selection)
        } else {
          this.$emit('selection', selection)
        }
      },
      deleteCurrent(item, index) {
        this.allPageSelection.splice(index, 1)
        this.splitSelection()
      },
      allAllSelection(resArr) {
        let allId = this.allPageSelection.map(x => this.getSelectionKey(x))
        for (let item of resArr) {
          if (allId.indexOf(this.getSelectionKey(item)) === -1) {
            this.allPageSelection.splice(this.allPageSelection.length, 0, item)
          }
        }
        this.splitSelection()
      },
      mergeSelection(data) {
        let insertArr = []
        let deleteArr = []
        let currentId = []
        for (let item of this.currentPageSelection) {
          currentId.push(this.getSelectionKey(item))
        }
        for (let item of data) {
          if (currentId.indexOf(this.getSelectionKey(item)) === -1) {
            insertArr.push(item)
            this.allPageSelection.splice(this.allPageSelection.length, 0, item)
          }
        }

        let nId = []
        for (let item of data) {
          nId.push(this.getSelectionKey(item))
        }
        for (let item of this.currentPageSelection) {
          if (nId.indexOf(this.getSelectionKey(item)) === -1) {
            this.deleteAllSelection(this.getSelectionKey(item))
            deleteArr.push(this.getSelectionKey(item))
          }
        }
        this.currentPageSelection = GlobalUtil.deepClone(data)
        let emitData = {
          insertArr: insertArr,
          deleteArr: deleteArr,
          allPageSelection: this.allPageSelection
        }
        this.$emit('selectionAllPage', emitData)
      },
      deleteAllSelection(id) {
        for (let j in this.allPageSelection) {
          let jtem = this.allPageSelection[j]
          if (this.getSelectionKey(jtem) === id) {
            this.allPageSelection.splice(j, 1)
            break
          }
        }
      },
      getSelectionKey(item) {
        return this.isAllMultiple.callback(item)
      },
      splitSelection() {
        let allArr = GlobalUtil.deepClone(this.allPageSelection)
        //拆分所有选中项->当前页选中项和其他页选中项
        let current = []
        let other = []
        let currentIndex = []
        for (let item of allArr) {
          let isCurrent = false
          for (let j in this.tableData.tData) {
            let jtem = this.tableData.tData[j]
            if (this.getSelectionKey(item) === this.getSelectionKey(jtem)) {
              isCurrent = true
              currentIndex.push(parseInt(j))
              break
            }
          }
          if (isCurrent) {
            current.push(item)
          } else {
            other.push(item)
          }
        }
        this.currentPageSelection = GlobalUtil.deepClone(current)
        //其他页选中项
        this.otherPageSelection = GlobalUtil.deepClone(other)
        //反选其中选中项
        this.selectIndex(currentIndex)

      },
      handleSizeChange(val) {
        this.ajax.data.pageSize = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.ajax.data.pageNumber = val
        this.getList()
      },
      rowclassname(row) {
        // console.log(row)
        if (row.rowIndex == this.tableData.tData.length - 1) {
          return 'hhhhhhhh'
        }
        // if ((++row.rowIndex % 2) == 0) {
        //   return "rowstylebg";
        // }
      },
      // 操作点击
      optionHandleClick(type, row, s) {
        this.allClick(type, row, s)
      },
      // 排序
      sortChange(obj) {
        this.sortData = this.sortFormatter(obj)
        this.getList()
      },
      selectIndex(rows) {
        this.selectionIndex = rows
        this.toggleSelection()
      },
      toggleSelection() {
        this.$nextTick(function () {
          let arr = GlobalUtil.deepClone(this.selectionIndex)
          if (arr && arr.length > 0) {
            this.$refs.refDataTable.clearSelection()
            for (let row of arr) {
              this.$refs.refDataTable.toggleRowSelection(this.tableData.tData[row], true)
            }
          } else {
            this.$refs.refDataTable.clearSelection()
          }
        })
      },
      exportAction(name) {
        // this.loading = true;
        let posdata = Object.assign({},
          this.ajax.data.queryObj,
          this.serachFilte.queryObj,
          this.sortData
        )
        console.log(posdata)
        // return false;
        // console.log(this.tableData.tHead);
        let tHeadArr = this.tableData.tHead
        let dataArr = []
        let fieldArr = []
        let headArr = []
        // console.log('getList')
        this.$axios
          .ajax({
            url: this.ajax.url,
            method: this.ajax.method,
            data: {
              queryObj: posdata
            }
          }).then(res => {
          // console.log(res.data)
          if (!res.msg) {
            let resArr = res.data.list ? res.data.list : res.data
            let bakArr = []
            for (var item of tHeadArr) {
              if (item.type != 'actionBtns') {
                headArr.push(item.name)
                fieldArr.push(item.field)
                bakArr.push(item)
              }

            }
            for (var item1 of resArr) {
              let obj = {}
              for (var k of bakArr) {
                if (k.type == 'function') {
                  let str = k.callback(item1[k.field], item1)
                  var reg = /<[^>]+>/g
                  if (reg.test(str)) {
                    obj[k.field] = str.replace(/<\/?[^>]+>/g, '')
                  } else {
                    obj[k.field] = str
                  }
                } else {
                  obj[k.field] = item1[k.field] == null || item1[k.field] == 'undefined' ? '-' : item1[k.field]
                }
              }
              dataArr.push(obj)

            }
            this.exportExcel(headArr, fieldArr, dataArr, name)
          }

        })
      },
      // 导出表格
      exportExcel(headers, filterVals, dataList, name) {
        var that = this
        require.ensure([], () => {
          const {
            export_json_to_excel
          } = require('@/utils/Export2Excel')

          const tHeader = headers // 上面设置Excel的表格第一行的标题

          const filterVal = filterVals // 上面的index、nickName、name是tableData里对象的属性

          const list = dataList //把data里的tableData存到list

          const data = this.formatJson(filterVal, list)
          let date = name + '_' + GlobalUtil.dateFormat(new Date(), 'YYYYMDHms')

          export_json_to_excel(tHeader, data, date) //标题，数据，文件名
        })
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
      //定义导出Excel表格事件
      exportExcels(name) {

        let date = GlobalUtil.dateFormat(new Date(), 'YYYY-M-D')
        /* 从表生成工作簿对象 */
        let fix = document.querySelector('.el-table__fixed')
        let wb
        if (fix) {
          wb = XLSX.utils.table_to_book(document.querySelector('#out-table').removeChild(fix))
          // document.querySelector("#out-table").appendChild(fix);
        } else {
          wb = XLSX.utils.table_to_book(document.querySelector('#out-table'))
        }
        /* 获取二进制字符串作为输出 */
        var wbout = XLSX.write(wb, {
          bookType: 'xlsx',
          bookSST: true,
          type: 'array'
        })
        try {
          FileSaver.saveAs(
            //Blob 对象表示一个不可变、原始数据的类文件对象。
            //Blob 表示的不一定是JavaScript原生格式的数据。
            //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
            //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
            new Blob([wbout], {
              type: 'application/octet-stream'
            }),
            //设置导出文件名称
            name ? name + '-' + date + '.xlsx' : '数据.xlsx'
          )
        } catch (e) {
          if (typeof console !== 'undefined') console.log(e, wbout)
        }
        return wbout
      },
      showQrcode(data, row, scope) {
        // console.log(data)
        if (data.qrcodeCfg.response) {
          const outData = {
            type: data.field,
            rowData: row,
            rowindex: scope.$index
          }
          this.$emit('rowClick', outData)
        } else {
          if (typeof data.qrcodeCfg.callback === 'function') {
            this.qrCodeData = GlobalUtil.deepCopy(data.qrcodeCfg.callback(row))
            this.qrcodeDialogVisible = true
          }
        }
      }
    },
    watch: {
      inSerachFilte: {
        handler(newData, oldData) {
          console.log('inSerachFilte')
          console.log(newData)
          this.serachFilte = newData
          this.ajax.data.pageNumber = 1
          this.getList()
        },
        deep: true
      },
      flush: {
        handler(newData, oldData) {
          this.getList()
        },
        deep: true
      },
      inAjax: {
        handler(newData, oldData) {
          // console.log('inAjax')
          this.ajax = this.inAjax
          this.tableData = this.inTableData
          this.serachFilte = this.inSerachFilte
          this.getList()
        },
        deep: true
      }
    }
  }

</script>
<style lang="scss" scoped>
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .lyk-table-container {
    // border-radius: 5px;
    // padding: 24px;
    // border: 1px solid rgba(85, 84, 84, 0.2);
  }

  .lyk-table-container:hover {
    // box-shadow: 1px 1px 10px 1px #d6d4d4;
  }


  .dialog_content {
    .thead {
      line-height: 40px;
      // text-align: center;
      background: rgb(224, 220, 220);
    }

    .tbody {
      line-height: 40px;
    }

    .table_col {
      width: 100%;
      height: 40px;
      // text-align: center;
    }

    .table_col p {
      display: block;
      width: 160px;
    }

    .table_col:hover {
      background: #eee;
    }

  }

  .img-text {
    display: flex;

    .text-field {

      line-height: 90px;
      white-space: nowrap;
      padding-left: 19px;
    }
  }

  .lyk_table {
    //width: 100%;
    /*height: 100%;*/
    padding-top: 18px;
    padding-bottom: 14px;
  }

  .table_qrcode_btn {
    width: 14px;
    height: 14px;
    position: relative;
    top: 4px;
    padding-right: 5px;
  }

</style>
<style>
  .default_image {
    width: 35px;
    height: 27px;
    margin: 0 auto;
    margin-top: 12px;
  }

  .text_center {
    text-align: left;
  }

  .textLeft .cell {
    text-align: left !important;

    /* color: red; */
  }

  /* 清除默认样式 */
  .lyk_table .el-table--border {
    border: none;
  }

  .lyk_table .cell {
    /* text-align: center; */
    cursor: pointer;
    /* text-indent:1em; */
    /* padding-left: 10px; */

  }

  .el-table__fixed-right {
    height: 100% !important;
  }

  .lyk_table .cell span {
    /* overflow:hidden; 
    text-overflow:ellipsis;
     white-space: nowrap; */
  }

  /* .el-main{
    padding: 20px 0px;
} */
  .lyk_table .el-table td,
  .el-table th {
    padding: 0;
  }

  .lyk_pagination {
    text-align: right;
    border-top: 1px solid rgba(195, 197, 198, 0.5);
    padding-top: 42px;
    line-height: 30px;
    padding-right: 20px;

  }

  .el-pagination__total {

    position: relative;

  }

  /* 表头设置 */
  .lyk_table tr th {
    height: 50px;
  }

  .lyk_table .el-input-number {
    width: 100px;

  }


  /* .lyk_table .rowstylebg {
    background: rgba(247, 251, 252, 1) !important;
  } */
  input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }

  input[type="number"] {
    -moz-appearance: textfield
  }
</style>
